type OptionWithVisibility<T> = {
  isVisible?: boolean | ((option: T) => boolean)
  showInDetailedMenu?: boolean
}

export function isOptionVisible<T>(option: T & OptionWithVisibility<T>) {
  if (typeof option.isVisible === "function") {
    return option.isVisible(option)
  }
  return option.isVisible ?? true
}

export function isOptionShownInDetailedMenu<T>(option: T & {
  showInDetailedMenu?: boolean
}) {
  return option.showInDetailedMenu ?? true
}

export function canRenderToolbarOption<T>(
  option: T & OptionWithVisibility<T>,
  { detailed }: { detailed?: boolean } = {}
) {
  return (
    isOptionVisible(option) &&
    (!detailed || isOptionShownInDetailedMenu(option))
  )
}
